import { useCreditPrices } from '@parsina/framework/clinical/src/lib/useCreditPrices';
import { hasRailFor } from '../constants/paymentGateway';

/**
 * Can the doctor buy پارسه here, and at what price (PM-0211,
 * docs/platform-money/CONTRACT.md §6)?
 *
 *   canBuy       the deployment sells credit (`creditPrices.purchaseAvailable`;
 *                until the BFF has said, the market: Iran yes, elsewhere no)
 *                AND this panel has a rail for its currency (constants/
 *                paymentGateway.js — Iranian gateways, toman only). Every «خرید
 *                پارسه» / «شارژ اعتبار» entry point in this app asks this, never
 *                `isIranMarket()` alone.
 *   creditPrice  `{ amountMinor, currency }` of ONE credit — toman (IRT) for
 *                Parsina: the policy's figure, else the constant, as before.
 *   packages     the deployment's own packages, or null: the surface keeps its list.
 */
export function useCreditPurchase() {
  const { purchaseAvailable, creditPrice, packages } = useCreditPrices();
  return {
    canBuy: Boolean(purchaseAvailable) && hasRailFor(creditPrice?.currency),
    creditPrice,
    packages,
  };
}

export default useCreditPurchase;
